import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import CardSummary from './CardSummary';
import Heading from '../common/Heading';
import LoaderButton from '../loader-button/LoaderButton';

export default function IntegrationStatus({
  loadingServices,
  dashboardSections,
  updateServices,
  services,
  isShowOperational,
  setIsShowError,
  isShowNotConfigured,
  setIsShowNotConfigured,
  setIsShowOperational,
  isShowError,
  handleVendorCardFiltering
}) {
  return (
    <>
      <div>
        <Heading
          title="Integration Status"
          subtitle={`Current integration status`}
          className={`mb-2 ${dashboardSections[0]?.active ? 'mt-5' : 'mt-3'}`}
          icon="cog"
        />
      </div>

      <Row>
        <Col>
          <input
            type="checkbox"
            id="operational"
            label="Enable Provider"
            checked={isShowOperational}
            onChange={e => handleVendorCardFiltering(e, setIsShowOperational)}
            className="mb-4"
            data-testid={'enable-provider'}
          />
          <label className="ml-2">Show Operational</label>
          <input
            type="checkbox"
            id="error"
            label="Enable Provider"
            checked={isShowError}
            onChange={e => handleVendorCardFiltering(e, setIsShowError)}
            className="mb-4 ml-4"
            data-testid={'enable-provider'}
          />
          <label className="ml-2">Show Errors</label>
          <input
            type="checkbox"
            id="notconfig"
            label="Enable Provider"
            checked={isShowNotConfigured}
            onChange={e => handleVendorCardFiltering(e, setIsShowNotConfigured)}
            className="mb-4 ml-4"
            data-testid={'enable-provider'}
          />
          <label className="ml-2">Show Not Configured</label>
        </Col>
        <Col className="text-right">
          <LoaderButton
            className={`btn btn-falcon-danger mr-2 mb-3`}
            onClick={updateServices}
            name="save-and-add"
            data-testid={'refresh-stats-btn'}
            isLoading={loadingServices}
          >
            Refresh Stats
          </LoaderButton>
        </Col>
      </Row>
      {/* Add filter by status checkboxes */}

      <Row noGutters>
        {services
          ?.filter(s => {
            if (isShowError && s.status === 'ERROR') {
              return true;
            }
            if (isShowNotConfigured && s.status === 'NOT CONFIGURED') {
              return true;
            }
            if ((isShowOperational && s.status === 'OPERATIONAL') || s.status === 'RUNNING') {
              return true;
            }
            return false;
          })
          ?.map(service => {
            let color = 'warning';
            switch (service.status) {
              case 'OPERATIONAL':
                color = 'green';
                break;
              case 'NOT CONFIGURED':
              case 'PENDING':
                color = 'blue';
                break;
              case 'ERROR':
                color = 'red';
                break;
              case 'RUNNING':
                color = 'light-blue';
                break;
              default:
                break;
            }
            return (
              <Col key={service?.name} xs={6} className="col-xxl-4 mb-1 pr-md-2 pl-xxl-2">
                <CardSummary
                  title={service?.status}
                  color={color}
                  linkText="View"
                  to={service?.vendorId}
                  message={service?.message}
                  errors={service?.vendorData?.errors}
                  timestamp={service?.vendorData?.timestamp}
                >
                  {service?.name?.replace('Systems', 'Networks')}
                </CardSummary>
              </Col>
            );
          })}
      </Row>
    </>
  );
}

IntegrationStatus.propTypes = {
  loadingServices: PropTypes.bool,
  dashboardSections: PropTypes.array,
  updateServices: PropTypes.func,
  services: PropTypes.array,
  isShowOperational: PropTypes.bool,
  setIsShowError: PropTypes.func,
  isShowNotConfigured: PropTypes.bool,
  setIsShowNotConfigured: PropTypes.func,
  setIsShowOperational: PropTypes.func,
  isShowError: PropTypes.bool,
  handleVendorCardFiltering: PropTypes.func
};
